<div class="open-pending-card">
  <app-repair-buttons
    (updateState)="updateAssetState($event)"
    [canAssignMechanic]="canAssignMechanic"
    [defectSelected]="selectionModel.hasValue()"
    [disabledButtonsDuePermissions]="disabledRepairButtons"
    [selection]="selectionModel.selected"
    class="title-buttons"
  ></app-repair-buttons>

  <table
    mat-table
    multiTemplateDataRows
    matSort
    id="asset-open-defect-table"
    [dataSource]="dataSource"
    matSortActive="severity"
    matSortDirection="desc"
    matSortDisableClear="true"
    (matSortChange)="onMatSortChange($event)"
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th
        mat-header-cell
        *matHeaderCellDef
        scope="col"
      >
        <span class="visually-hidden">{{ "select" | i18next: { format: "capitalize" } }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let row"
      >
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selectionModel.toggle(row) : null"
          [checked]="selectionModel.isSelected(row)"
          [ngClass]="{ 'rejected-checkbox': isRejectedDefect(row) }"
          [disabled]="isRejectedDefect(row)"
        >
          <span class="visually-hidden">{{ checkboxLabel(row) }}</span>
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- Severity Column -->
    <ng-container matColumnDef="severity">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "severity" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        <img [src]="getSeverityIcon(defect.severity)"
          [alt]="defect.severity ? (('severity' | i18next) + ' ' + defect.severity) : ('severity' | i18next)" />
      </td>
    </ng-container>

    <!-- Inspection Type Column -->
    <ng-container matColumnDef="inspectionType">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "inspection" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        <a routerLink="/company/{{ companyId }}/inspection/{{ defect.inspectionId }}">
          {{ defect.inspectionType }}
        </a>
      </td>
    </ng-container>

    <!-- Zone Column -->
    <ng-container matColumnDef="zoneLabel">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "zone" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ defect.zoneLabel }}
      </td>
    </ng-container>

    <!-- Component Column -->
    <ng-container matColumnDef="componentLabel">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "component" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ defect.componentLabel }}
      </td>
    </ng-container>

    <!-- Condition Column -->
    <ng-container matColumnDef="conditionLabel">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "condition" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ defect.conditionLabel }}
      </td>
    </ng-container>

    <!-- Last Inspection Column -->
    <ng-container matColumnDef="lastNoted">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "last inspection" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ formatDate(defect.lastNoted) }}
      </td>
    </ng-container>

    <!-- First Inspection Column -->
    <ng-container matColumnDef="firstNoted">
      <th
        mat-header-cell
        *matHeaderCellDef
        scope="col"
      >
        {{ "first inspection" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ formatDate(defect.firstNoted) }}
      </td>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="defectStatus">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        scope="col"
      >
        {{ "status" | i18next: { format: "uppercase" } }}
      </th>
      <td
        mat-cell
        *matCellDef="let defect"
      >
        {{ defect.defectStatus }}
      </td>
    </ng-container>

    <!-- Click to expand hidden column -->
    <ng-container matColumnDef="chevron">
      <th
        mat-header-cell
        *matHeaderCellDef
        scope="col"
      >
        <span class="visually-hidden">{{ "details" | i18next: { format: "capitalize" } }}</span>
      </th>
      <td
        mat-cell
        *matCellDef="let defect; let i = dataIndex"
      >
        <mat-icon
          id="expand-photo-repair"
          class="expand-icon"
          role="button"
          tabindex="0"
          [attr.aria-label]="'details' | i18next"
          *ngIf="defect.repairs || defect.photos"
          [@rotatedState]="rotateState[i]"
          (click)="showExpansion(defect); rotate(i)"
          (keydown.enter)="showExpansion(defect); rotate(i)"
          (keydown.space)="showExpansion(defect); rotate(i)"
        >
          expand_more
        </mat-icon>
      </td>
    </ng-container>

    <!-- Expandable notes row -->
    <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let defect"
        [attr.colspan]="displayedColumns.length"
      >
        <div
          class="expanded-row"
          [@detailExpand]="expansionAnimation(defect, expandedElement)"
          fxLayout="row"
        >
          <!-- if there are repairs, loop through to display each comment and timestamp -->
          <div
            *ngIf="defect.repairs"
            class="expanded-row-content"
            fxLayout="column"
            fxFlex="50"
          >
            <div class="content-header">{{ "notes" | i18next: { format: "uppercase" } }}</div>
            <div
              *ngFor="let repair of defect.repairs"
              class="content-margin pending-notes"
              fxLayout="row"
            >
              <div fxFlex="25">
                {{ formatDate(repair.created) }}
              </div>
              <div fxFlex="65">
                {{ repair.comment }}
              </div>
            </div>
          </div>

          <!-- if there are photos of the defect, loop through to display each photo -->
          <div
            *ngIf="defect.photos"
            class="expanded-row-content"
            fxLayout="column"
            fxFlex="50"
          >
            <div class="content-header">{{ "defect photos" | i18next: { format: "uppercase" } }}</div>
            <div
              class="image-content-margin"
              fxLayout="row wrap"
            >
              <div *ngFor="let photo of defect.photos; let i = index">
                <img
                  [id]="'defect-thumbnail-' + defect.defectId + '-' + (i + 1)"
                  class="thumbnail"
                  [src]="photo.sanitizedImage"
                  [alt]="('defect thumbnail' | i18next) + ' ' + (defect.defectId) + ' ' + (i + 1)"
                  (click)="handleImageClick(defect, i)"
                  (keydown.enter)="handleImageClick(defect, i)"
                  (keydown.space)="handleImageClick(defect, i)"
                  tabindex="0"
                  role="button"
                />
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayedColumns"
    ></tr>
    <tr
      mat-row
      *matRowDef="let defect; columns: displayedColumns; let i = dataIndex"
      [ngClass]="getDividerClass(defect, i)"
    ></tr>

    <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']; let i = dataIndex"
      class="detail-row"
      [ngClass]="getDividerClass(row, i)"
    ></tr>
  </table>

  <app-no-results-card
    *ngIf="noDefects"
    [message]="noDefectsString"
  ></app-no-results-card>

  <div [hidden]="noDefects">
    <app-paginator
      #appPaginator
      [length]="totalOpenDefects"
      [pageSizeOptions]="pageSizeOptions"
      (pageQueryChange)="onQueryChange($event)"
    ></app-paginator>
  </div>
</div>
